const formatUserToState = (user) => ({
  id: user.id,
  roles: user.userRoles,
  email: user.email,
  username: user.username,
  firstName: user.firstName,
  lastName: user.lastName,
  fullName: `${user.firstName} ${user.lastName}`,
  avatar: user.avatar,
});

export default formatUserToState;
